
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/introduce/new",
      function () {
        return require("private-next-pages/introduce/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/introduce/new"])
      });
    }
  